import React from 'react';

import styles from './styles/styles.module.scss';

export default function ReviewCount({ className, count }) {
  const classes = [styles.count];
  if (className) {
    classes.push(className);
  }
  if (!count) {
    return null;
  }
  return <span className={classes.join(' ')}>{`(${count})`}</span>;
}
